<template lang="pug">
    header(ref="header")
        button.hamburger.hamburger--3dy(type="button" :class="{ 'is-active': sidebar }" @click="toggleSidebar")
            span.hamburger-box
                span.hamburger-inner
            .mobile-logo.is-visible-touch.is-visible-desktop-only
                img.is-pulled-left(v-if="logo && logo.id" :src="image.src" title="logo" rel="noopener")
                img.is-pulled-left(v-else src="@/assets/logo.png")
        .container.is-hidden-touch.is-hidden-desktop-only.is-hidden-scrolled#not-fixed-menu
            HeaderMenu.navbar
            .columns
                a(href="/").logo-wrapper
                    img#logo.is-pulled-left(v-if="logo && logo.id" :src="image.src" title="logo" rel="noopener")
                    img#logo.is-pulled-left(v-else src="@/assets/logo.png")
                .main-menu-wrapper.column
                    nav#main-menu.is-pulled-right
                        tree-menu(:items="items" :max-depth="3" :delay="400")
        .header-menu-fixed.main-menu-wrapper.is-fixed-top#fixed-menu
            .container
                nav#main-menu
                    a(href="/").logo-wrapper
                        img#logo.sticky(src="@/assets/logo.png")
                    tree-menu.is-centered(:items="items" :max-depth="3" :delay="400")
</template>

<script>

// import _ from 'lodash'
import get from 'lodash.get'
import trim from 'lodash.trim'
import cloneDeep from 'lodash.clonedeep'
import HeaderMenu from '@/components/HeaderMenu.vue'
import Logo from '@/components/Logo.vue'

import { mapGetters, mapMutations } from 'vuex'

import NestedSet from '@/nested-set-lib'

export default {
    name: 'Header',
    components: {
        HeaderMenu,
        Logo
    },
    computed: {
        items() {
            const menu = this.menus.find(menu => menu.key === 'main-menu')
            let items = get(menu, 'menuItems') || []
            items = cloneDeep(items)

            if (items.length) {
                return NestedSet.createTree(items)
            }

            return items
        },
        image() {
            const storageRoute = trim(`${process.env.VUE_APP_API_ENDPOINT}${process.env.VUE_APP_API_PUBLIC_STORAGE_ROUTE}`, '/')

            const fit = 'fit=&h=85'

            let width = this.logo.width
            let height = this.logo.height

            return {
                src: `${storageRoute}/images/${this.logo.id}/${this.logo.name}?${fit}`,
                error: `${storageRoute}/images/${this.logo.id}/${this.logo.name}?${fit}&preview=greyscale`,
                loading: `${storageRoute}/images/${this.logo.id}/${this.logo.name}?${fit}&preview=blur`,
                width,
                height,
            }
        },
        ...mapGetters({
            logo: 'logo',
            menus: 'menus',
            sidebar: 'sidebar',
        })
    },
    methods: {
        openSearch() {
            console.log('open search bar');
        },
        toggleSidebar() {
            this.updateSidebarVisibility(! this.sidebar)
        },
        ...mapMutations({
            updateSidebarVisibility: 'updateSidebarVisibility',
        }),
        toggleVisibility(status) {
            if ( status === 'hide') {
                document.getElementById('fixed-menu').style.display = 'block'
            }else if ( status === 'show' ){
                document.getElementById('fixed-menu').style.display = 'none'
            }
        }
    },
    mounted() {
        const headerHeight = this.$refs.header.offsetHeight
        document.addEventListener('scroll', (event) => {
            if( window.innerWidth >= 1088 && (window.scrollY + 50) >= headerHeight) {
                this.toggleVisibility('hide')
            }else this.toggleVisibility('show')
        })
    }
}
</script>

<style lang="sass" scoped>

    @import "~bulma/sass/utilities/mixins"
    @import '~@/assets/sass/variables'
    header
        background-color: #fff
        // padding-top: 50px
        // padding-bottom: 50px
        border-bottom: 15px solid none
        #logo
            // height: 155px
            max-width: 370px
        #fixed-menu
            display: none
            position: fixed
            top: 0
            width: 100%
            z-index: 99
            background-color: #fff
            border-bottom: 1px solid $primary
            .container
                height: unset
                padding: 0 1.5rem 0 1.5rem
                #main-menu
                    display: flex
                    flex-direction: row
                    justified-content: space-between
                svg
                    width: 100px
                .tree-menu
                    width: 100%
                    display: flex
                    justify-content: flex-end
                    margin-left: 50px
        .hamburger
            height: 100px
            outline: none
            +widescreen
                display: none
            .hamburger-inner
                background-color: $primary
                &:before
                    background-color: $primary
                &:after
                    background-color: $primary

        .container
            margin-top: 0.75rem
            height: 175px
            .columns
                height: 85%
                padding: 0 1.5rem
                .logo-wrapper
                    display: flex
                    justify-content: center
                    flex-direction: column
                    position: absolute
                    height: 80%
                    height: calc(100% - 40px - 50px)
                    top: 45px
                    left: 0
                .main-menu-wrapper.column
                    display: flex
                    justify-content: flex-end
                    a.search
                        background-color: $primary
                        color: #fff
                        height: 40px
                        width: 40px
                        border-radius: 30px
                        &:hover
                            color: #fff

        .main-menu-wrapper
            margin-top: auto
            padding-bottom: 0
            .navbar-item
                // color: #879507 !important

            #main-menu
                z-index: 10
                &::v-deep
                    ul
                        &.tree-menu
                            & > li
                                transition: background-color .3s ease
                                &:not(.full-width)
                                    position: relative
                                & > .tree-item a
                                    text-decoration: none
                                    font-weight: 800
                                    text-transform: normal
                                    color: $black
                                    padding: 7px
                                    display: inline-block
                                    transition: color .3s ease
                                &.hover
                                    // background-color: $secondary
                                    & > .tree-item a
                                        color: #000
                                li
                                    // padding: 0 9px
                                    width: 100%
                                    background-color: $primary
                                    & > .tree-item a
                                        font-size: 95%
                                        font-weight: normal
                                        color: #fff
                                        display: block
                                        max-width: 200px
                                        overflow: hidden
                                        text-overflow: ellipsis
                                        white-space: nowrap
                                        border-bottom: 1px solid #fff
                                        // &:before
                                        //     font-family: 'Font Awesome 5 Free' !important
                                        //     speak: none
                                        //     font-weight: 900
                                        //     content: '\f054'
                                        //     color: #000
                                        //     padding-right: 6px
                                        //     transition: color .3s ease
                                    &.hover
                                        background-color: #fff
                                        & > .tree-item a
                                            // color: $secondary
                                            &:before
                                                color: $secondary
                                li:last-child
                                    & > .tree-item a
                                        border-bottom: none
                    & > ul
                        &.tree-menu
                            & > li
                                // padding: 0 9px 33px 9px
                                display: inline-block
                                & > .tree-item a
                                    padding: 15px 18px 5px 18px
                                    border-bottom: 5px solid transparent
                                    font-size: 0.9rem
                                    &.router-link-exact-active
                                        color: $primary
                                        border-bottom: 2px solid $primary
                                &.hover > .tree-item a.router-link-exact-active
                                    color: #000
                                & > ul
                                    &.tree-menu
                                        position: absolute
                                        left: 0
                                        top: 100%
                                        display: flex
                                        flex-direction: column
                                        min-width: 200px
                                        box-shadow: 0px 5px 10px 0px rgba(0,0,0,0.3)
                                        &.full-width
                                            width: 100%
                                            columns: 3
                                            column-gap: 0
                                            display: block
                                            +widescreen
                                                columns: 4
                                        .li:first-child
                                            border-radius: 10px 10px 0 0
                            ul 
                                ul
                                    min-width: 200px
                                    margin-bottom: 9px
                                    position: absolute
                                    right: -100%
                                    top: 0
                                &:last-of-type
                                    ul
                                        right: 100%
                                // &::after
                                //     content: ""
                                //     position: absolute
                                //     left: -26px
                                //     top: 5px
                                //     width: 0
                                //     height: 0
                                //     border-style: solid
                                //     border-width: 13px 13px 13px 13px
                                //     border-color: transparent #80bb3d transparent transparent
                                //     z-index: 9998
                                // box-shadow: 0px 5px 10px 0px rgba(0,0,0,0.3)
                                li > .tree-item a
                                    // padding: 10px 15px
                                    // font-size: .8rem
                                    // &:before
                                    //     font-size: 0.5rem
                                    //     position: relative
                                    //     top: -1px

                    .show-enter-active, .show-leave-active
                        transition: opacity 0.3s ease, transform 0.3s ease
                        transform-origin: left center
                    .show-enter, .show-leave-to
                        opacity: 0
                        transform: translateY(6px)
    .mobile-logo
        padding-left: 70px
        position: absolute
        right: 8px
        top: 8px
        height: 80px
        display: flex
        align-items: center
    #logo.sticky
        max-width: 50px
</style>
